import type { match as Match } from 'react-router-dom';

export function buildStatDetailsPathname(match: Match) {
  return `${match.path}/:challengeId`;
}

export const STAT_SINGLE_PATHNAME = '/stats/:challengeId';
